import styles from "./MindoDalamAngka.module.css"
import { Col, Row } from "antd"
import CardAngka from "./CardAngka"

const MindoDalamAngka = () => {
  return (
    <div className={styles.body}>
      <div className="container">
        <Row
          gutter={[24, 24]}
          align="middle"
          justify="space-between"
          className={styles.wrapRow}>
          <Col span={8} className={styles.kiri} data-aos="fade-up">
            <h1 className={styles.title}>Mindo Education<br /> Dalam Angka</h1>
            <p className={styles.text}>
              Jejak keberhasilan yang mencerminkan kepercayaan industri dan
              akademisi terhadap kualitas program kami
            </p>
          </Col>

          <Col span={16} className={styles.kanan}>
            <Row gutter={[16, 16]} justify="center">
              <Col>
                <CardAngka
                  angka="30"
                  deskripsi="Perguruan tinggi yang menjadi mitra dalam pengembangan kompetensi"
                />
              </Col>
              <Col>
                <CardAngka
                  angka="50"
                  deskripsi="Perusahaan dan instansi yang telah mempercayakan pelatihan serta konsultasi sertifikasi"
                />
              </Col>
              <Col>
                <CardAngka
                  angka="100"
                  deskripsi="Kolaborasi, pelatihan, dan program kemitraan yang telah sukses diselenggarakan"
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default MindoDalamAngka
